import axios from 'axios';

//const API_URL = 'http://localhost:5199/api/';
const API_URL = 'https://dev-billeur-api-webapp-f3cnbwfybmhdbjap.westeurope-01.azurewebsites.net/api/';

const authAxios = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // ✅ Always send/receive cookies
  timeout: 10000,
});

authAxios.interceptors.request.use(
  (config) => {
    console.log('🔐 Auth request to:', config.url);
    return config;
  },
  (error) => {
    console.error('❌ Auth Request Error:', error);
    return Promise.reject(error);
  }
);

authAxios.interceptors.response.use(
  (response) => {
    console.log('✅ Auth response from:', response.config.url, response.status);
    return response;
  },
  (error) => {
    console.error('❌ Auth Response Error:', error.response?.status, error.response?.data);
    return Promise.reject(error);
  }
);

export default authAxios;